// src/data/translations.js
export const TRANSLATIONS = {
  fr: {
    nav: {
      home: "Accueil",
      gallery: "Galerie",
      book: "Réserver",
    },
    content: {
      subtitle: "Votre appart-hôtel à Delémont",
      features: [
        "🍳 Cuisine entièrement équipée",
        "🅿️ Parking gratuit sur place",
        "🧺 Machine à laver",
        "🌿 Terrasse privative",
      ],
      description1:
        "Studio neuf avec équipements modernes, situé dans un quartier paisible et écoresponsable. Profitez du parking gratuit et d'une arrivée autonome en toute simplicité. Idéal pour les voyageurs solo, les couples ou les professionnels. L’agencement intelligent convient aussi bien aux séjours courts qu’aux longues durées.",
      locationTitle: "Proche de toutes commodités",
      locationIntro: "Le centre de Delémont et les principaux points d'intérêt peuvent être rejoints à pied.",
      locations: [
        { name: "Centre-ville", distance: "5 minutes à pied", icon: "building" },
        { name: "Gare", distance: "10 minutes à pied", icon: "train" },
        { name: "Autoroute", distance: "3 minutes en voiture", icon: "car" }
      ]
    },
  },
  en: {
    nav: {
      home: "Home",
      gallery: "Gallery",
      book: "Book",
    },
    content: {
      subtitle: "Your apartment hotel in Delémont’s eco-district",
      features: [
        "🍳 Fully equipped kitchen",
        "🅿️ Free on-site parking",
        "🧺 Washing machine",
        "🌿 Private terrace",
      ],
      description1:
        "Modern studio in a quiet, eco-friendly neighborhood. Enjoy free parking and easy self check-in. Perfect for solo travelers, couples, or business guests. Smart layout designed for both short and extended stays.",
      locationTitle: "Close to all amenities",
      locationIntro: "Delémont's city center and main points of interest are within walking distance.",
      locations: [
        { name: "City Center", distance: "5 minutes walk", icon: "building" },
        { name: "Train Station", distance: "10 minutes walk", icon: "train" },
        { name: "Highway", distance: "3 minutes drive", icon: "car" }
      ]
    },
  },
  de: {
    nav: {
      home: "Home",
      gallery: "Galerie", 
      book: "Buchen",
    },
    content: {
      subtitle: "Ihr Apartmenthotel im Öko-Viertel von Delémont",
      features: [
        "🍳 Vollständig ausgestattete Küche",
        "🅿️ Kostenlose Parkplätze vor Ort",
        "🧺 Waschmaschine",
        "🌿 Private Terrasse",
      ],
      description1:
        "Modernes Studio in einem ruhigen, umweltfreundlichen Viertel. Kostenlose Parkplätze und unkomplizierter Selbst-Check-in. Ideal für Alleinreisende, Paare oder Geschäftsreisende. Durchdachte Raumaufteilung für kurze und längere Aufenthalte.",
      locationTitle: "Nahe zu allen Annehmlichkeiten",
      locationIntro: "Das Zentrum von Delémont und die wichtigsten Sehenswürdigkeiten sind zu Fuß erreichbar.",
      locations: [
        { name: "Stadtzentrum", distance: "5 Minuten zu Fuß", icon: "building" },
        { name: "Bahnhof", distance: "10 Minuten zu Fuß", icon: "train" },
        { name: "Autobahn", distance: "3 Minuten Fahrt", icon: "car" }
      ]
    },
  },
};

export const BOOKING_TRANSLATIONS = {
  fr: {
    title: "Réservez Votre Séjour",
    subtitle: "Choisissez votre plateforme de réservation",
    bookingCom: "Booking.com",
    airbnb: "Airbnb",
    email: "Contact Direct",
    emailDesc: "Réduction de 10% pour une réservation directe",
    paymentMethods: "TWINT | Virement",
    close: "Fermer",
  },
  en: {
    title: "Book Your Stay",
    subtitle: "Select your preferred booking platform",
    bookingCom: "Booking.com",
    airbnb: "Airbnb", 
    email: "Direct Contact",
    emailDesc: "10% discount for direct bookings",
    paymentMethods: "TWINT | Bank Transfer",
    close: "Close",
  },
  de: {
    title: "Ihren Aufenthalt Buchen",
    subtitle: "Wählen Sie Ihre bevorzugte Buchungsplattform",
    bookingCom: "Booking.com",
    airbnb: "Airbnb",
    email: "Direkter Kontakt", 
    emailDesc: "10% Rabatt bei Direktbuchung",
    paymentMethods: "TWINT | Überweisung",
    close: "Schließen",
  },
};




